<tt-page *ngIf="!!setting">
    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-button-goto [ttText]="'paycheckbatches_new'" (ttClick)="goToFunc('paycheckbatch')" ttIcon="fa fa-solid fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list class="col-xs-12 col-md-6 sp-0" [ttData]="itemsListPayCheckBatches"></tt-list>

    <tt-card class="col-xs-12 col-md-6 sp-0" *ngIf="setting.show_setting === '1'">
        <tt-button-settings></tt-button-settings>
    </tt-card>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-button class="col-xs-12 sp-0" tt-text="paycheckbatches_new" tt-click="vm.goToFunc('paycheckbatch')" tt-text-align="left" tt-icon="fa fa-solid fa-plus" tt-icon-pull-right="true"></tt-button>
    </tt-card>

    <im-list-directive class="col-xs-12 col-md-6 sp-0" list-items="vm.model.itemsListPayCheckBatches" badge="" ltype="" design-var="s12t0"></im-list-directive>

    <tt-card class="col-xs-12 col-md-6 sp-0" ng-if="vm.model.setting.show_setting === '1'">
        <tt-button-settings class="col-xs-12 sp-0" tt-locked=""></tt-button-settings>
    </tt-card>
</tt-page>-->
